module.exports = __webpack_public_path__ + "static/media/ljubljana-21.6111da94.jpg";